import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dates/styles.css";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { emotionTransform, MantineEmotionProvider } from "@mantine/emotion";
import { GlobalProvider } from "./context/globalContext";
import { AuthContextProvider } from "./auth/AuthContext";
import RouterFn from "./Router";

function App() {
  return (
    <AuthContextProvider>
      <MantineProvider
        stylesTransform={emotionTransform}
        theme={{
          colors: {
            brand: [
              "#c4d5ef",
              "#cdf0ff",
              "#a0cefa",
              "#a3d6ff",
              "#75b1e7",
              "#5fa0d0",
              "#498fc0",
              "#3269a0",
              "#1c527f",
              "#053c5f",
            ],
          },
          primaryColor: "brand",

          shadows: {
            md: "1px 1px 3px rgba(0, 0, 0, .25)",
            xl: "5px 5px 3px rgba(0, 0, 0, .25)",
          },

          headings: {
            fontFamily: "Roboto, sans-serif",
            sizes: {
              h1: { fontSize: "2rem" },
            },
          },
        }}
      >
        <MantineEmotionProvider>
          <Notifications position="top-right" />
          <GlobalProvider>
            <RouterFn />
          </GlobalProvider>
        </MantineEmotionProvider>
      </MantineProvider>
    </AuthContextProvider>
  );
}

export default App;
